import { memo } from 'react';
import cs from 'classnames';

import { makeStyles } from 'design-system/product/theme';

/* eslint-disable restrict-imports/restrict-imports */
import Alert, { AlertProps } from '@material-ui/lab/Alert';

const CatalogAlert = ({ classes, severity, children, ...otherProps }: AlertProps) => {
  const mergedClasses = { ...useStyles(), ...classes };
  return (
    <Alert
      variant={'filled'}
      classes={{
        root: mergedClasses.messageRoot,
        icon: cs(mergedClasses.icon, { [mergedClasses.icon_info]: severity === 'info' }),
        message: cs({ [mergedClasses.message_info]: severity === 'info' }),
      }}
      severity={severity}
      {...otherProps}
    >
      {children}
    </Alert>
  );
};

const useStyles = makeStyles(theme => ({
  messageRoot: {
    borderRadius: theme.borderRadius,
  },
  icon: {
    flexShrink: 0,
  },
  icon_info: {
    color: `${theme.palette.primary.main} !important`,
  },
  message_info: {
    color: `${theme.palette.primary.main} !important`,
  },
}));

export default memo(CatalogAlert);
